import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/auth";
import TablaVehiculos from "./tablaVehiculos";
import TablaClaseVehiculos from "./tablaClaseVehiculos";
import TablaEstadoVehiculos from "./tablaVehiculosEstadoCuenta";
import { ImpporTipo } from "./modalImpTipo";
import { ImpporDeuda } from "./modalImpDeuda";
import { ConfiguracionModuloVehiculo } from "./modalConfigMVehiculo";
import TablaUsuarioVehiculos from "./tablaUsuariosVehiculos";
import { Toasts } from "../../toasts";
import Menu from "../../comun/Menu/Menu";
import Item from "../../comun/Menu/Item";

function MenuImpuestoVe() {
  const { user } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const [titulo1] = useState();
  const [titulo2] = useState();
  const [tipoRep, setTipoRep] = useState();
  const [tipoRepd, setTipoRepd] = useState();
  const accconfigvehiculo = JSON.parse(
    localStorage.getItem("accconfigvehiculo")
  );
  const accrepcontvehideud = JSON.parse(
    localStorage.getItem("accrepcontvehideud")
  );
  const accreptipvehi = JSON.parse(localStorage.getItem("accreptipvehi"));

  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [tabla, setTabla] = useState(0);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  let op = require("../../../../src/modulos/datos");
  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };
  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (obj != null) {
    } else {
    }
  }, []);
  useEffect(() => {
    if (tabla === 5) {
      if (accreptipvehi.toString() === "0") {
        setToast({
          mostrar: true,
          mensaje: "No posee Permiso para este Reporte.",
          titulo: "Alerta.",
        });
        setTabla(0);
      } else {
        setTipoRep(1);
        setTabla(8);
      }
    } else if (tabla === 6) {
      if (accrepcontvehideud.toString() === "0") {
        setToast({
          mostrar: true,
          mensaje: "No posee Permiso para este Reporte.",
          titulo: "Alerta.",
        });
        setTabla(0);
      } else {
        setTipoRepd(2);
        setTabla(9);
      }
    } else if (tabla === 10) {
      if (accconfigvehiculo.toString() === "0") {
        setToast({
          mostrar: true,
          mensaje: "No posee Permiso para este Modulo.",
          titulo: "Alerta.",
        });
        setTabla(0);
      } else {
        setTabla(11);
      }
    }
  }, [tabla]);

  const actualizacionItem = {
    title: "Actualización",
    icon: "fas fa-user-plus",
    drop: [
      // {
      //   title: "Registro de Contribuyentes",
      //   itemClickValue: 1,
      //   icon: "fas fa-users-cog fa-fw me-1",
      // },
      {
        title: "Clasificador de Vehículos",
        itemClickValue: 2,
        icon: "fas fa-pen-square me-1",
      },
      {
        title: "Estados de Cuenta",
        itemClickValue: 3,
        icon: "fas fa-address-card me-1",
      },
    ],
  };
  const imprimirItem = {
    title: "Imprimir",
    icon: "fas fa-print me-2",
    drop: [
      {
        title: "General por Tipo",
        itemClickValue: 5,
        icon: "far fa-file-powerpoint me-1",
      },
      {
        title: "Contribuyentes con Deudas",
        itemClickValue: 6,
        icon: "far fa-file-powerpoint me-1",
      },
    ],
  };
  const configuracionItem = {
    title: "Configuración",
    icon: "fas fa-cog me-2",
    drop: [
      {
        title: "Configuración General",
        itemClickValue: 10,
        icon: "fas fa-users-cog fa-fw me-1",
      },
      {
        title: "usuarios",
        itemClickValue: 4,
        icon: "fas fa-users-cog fa-fw me-1",
      },
    ],
  };

  const vista = {
    0: <TablaVehiculos />,
    1: (
      <TablaVehiculos
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    2: (
      <TablaClaseVehiculos
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    3: (
      <TablaEstadoVehiculos
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    4: (
      <TablaUsuarioVehiculos
        menu={() => {
          setTabla(0);
        }}
      />
    ),
    8: (
      <ImpporTipo
        show={show}
        onHideCancela={() => {
          setTabla(0), setShow(false);
        }}
        titulo1={titulo1}
        titulo2={titulo2}
        tiporep={tipoRep}
      />
    ),
    9: (
      <ImpporDeuda
        show={show}
        onHideCancela={() => {
          setTabla(0), setShow(false);
        }}
        titulo1={titulo1}
        titulo2={titulo2}
        tiporepd={tipoRepd}
      />
    ),
    11: (
      <ConfiguracionModuloVehiculo
        show={show}
        onHideCancelam={() => {
          setTabla(0), setShow(false);
        }}
      />
    ),
  };

  return user &&
    <div>
      <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)}>
        <Item item={actualizacionItem} setTabla={setTabla} setShow={setShow} />
        <Item item={imprimirItem} setTabla={setTabla} setShow={setShow} />
        <Item item={configuracionItem} setTabla={setTabla} setShow={setShow} />

        <a
          href="/haciendaMunicipal"
          className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
        >
          <i className="fas fa-power-off me-2" />
          Salir
        </a>
      </Menu>
      <section className="col-12 m-0 p-0 d-flex align-items-center justify-content-center" style={{height:'90dvh'}}>
        {vista[tabla]}
      </section>

      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
}
export default MenuImpuestoVe;
